function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#de2219;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M-83.112,460.6a16.229,16.229,0,0,1,5.307-6.752.231.231,0,0,1,.365.191,13.659,13.659,0,0,0,1.12,5.953,35.4,35.4,0,0,0,2.246,4.39,7.987,7.987,0,0,1-.794,8.168c-3.416,4.081-8.688,2.174-8.688,2.174a6.651,6.651,0,0,1-4.749-5.978c-.156-4.681,2.73-10.59,3.707-11.776a.182.182,0,0,1,.32.128c-.081,1.213-.09,4.127,1.47,5.773a1.88,1.88,0,0,1,.2,2.432c-.421.553-.961.852-1.523.075a2.448,2.448,0,0,1-.141-2.565Z",
  transform: "translate(88.313 -453.802)"
});

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 21.363,
    viewBox: "0 0 15 21.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.6da7542d.svg";
export { ForwardRef as ReactComponent };